<template>
  <Teleport to="#snackbar">
    <Transition
      enter-active-class="duration-200 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0">
      <div v-if="shown && toasts.length > 0" class="fixed bottom-3 left-3">
        <TransitionGroup
          move-class="duration-200 transition"
          enter-active-class="duration-200 ease-out"
          enter-from-class="transform opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-200 ease-in "
          leave-from-class="opacity-100"
          leave-to-class="transform opacity-0"
          tag="div"
          class="flex flex-col items-start gap-2">
          <div
            v-for="toast in toasts"
            :key="toast.id"
            class="flex items-center gap-x-3 rounded-xl bg-neutral-primary px-4 py-3 text-sm text-neutral shadow-md">
            <component :is="toast.renderFn" v-if="toast.renderFn" />
            <template v-if="!toast.renderFn">
              <UiIcon v-if="toast.icon" :name="toast.icon" />
              {{ toast.message }}
            </template>
          </div>
        </TransitionGroup>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { storeToRefs } from "pinia";

import { useToaster } from "@/composition/shared/useToaster.ts";

const store = useToaster();
const { toasts, shown } = storeToRefs(store);
</script>
